import React, { useEffect, useState } from 'react';
import Papa from 'papaparse';

const SMTPManager = () => {
  const [configs, setConfigs] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  const fetchConfigs = async () => {
    const res = await fetch('/api/smtp');
    const data = await res.json();
    setConfigs(data);
  };

  useEffect(() => {
    fetchConfigs();
  }, []);

const toggleSelect = (id) => {
  setSelectedIds((prev) =>
    prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
  );
};

const handleBulkDelete = async () => {
  if (selectedIds.length === 0) return alert('No SMTPs selected.');
  if (!window.confirm(`Delete ${selectedIds.length} SMTP(s)?`)) return;

  const res = await fetch('/api/smtp/bulk-delete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ids: selectedIds }),
  });

  const result = await res.json();
  if (result.success) {
    alert(`Deleted ${result.deleted} SMTP(s).`);
    setSelectedIds([]);
    fetchConfigs();
  } else {
    alert('Delete failed: ' + result.error);
  }
};

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this SMTP config?')) return;
    await fetch(`/api/smtp/${id}`, { method: 'DELETE' });
    fetchConfigs();
  };

  const handleCSVUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        if (!results.data[0]?.host || !results.data[0]?.username) {
          alert("CSV must include at least 'host' and 'username' fields.");
          return;
        }
        setCsvData(results.data);
      }
    });
  };

  const handleBulkImport = async () => {
    const smtps = csvData.map(s => ({
      name: s.name || s.username,
      host: s.host,
      port: parseInt(s.port),
      secure: s.secure === 'true' || s.secure === true,
      username: s.username,
      password: s.password,
    }));

    const res = await fetch('/api/smtp/bulk', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ smtps }),
    });

    const result = await res.json();
    if (result.success) {
      alert(`Imported ${result.inserted} SMTPs`);
      setCsvData([]);
      fetchConfigs();
    } else {
      alert('Import failed: ' + result.error);
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: '40px auto', padding: 20 }}>
      <h2>SMTP Manager</h2>
      <input type="file" accept=".csv" onChange={handleCSVUpload} />
      {csvData.length > 0 && (
        <div>
          <p>Previewing {csvData.length} SMTPs:</p>
          <ul>
            {csvData.map((s, i) => (
              <li key={i}>{s.username} @ {s.host}:{s.port} ({s.secure ? 'SSL' : 'TLS'})</li>
            ))}
          </ul>
          <button onClick={handleBulkImport}>Import All</button>
        </div>
      )}
      <h4>Existing SMTPs:</h4>
      <ul>
  {configs.map((smtp) => (
    <li key={smtp.id}>
      <input
        type="checkbox"
        checked={selectedIds.includes(smtp.id)}
        onChange={() => toggleSelect(smtp.id)}
        style={{ marginRight: 8 }}
      />
      <strong>{smtp.name}</strong> – {smtp.host}:{smtp.username}/{smtp.port} ({smtp.secure ? 'SSL' : 'TLS'})
      <button onClick={() => handleDelete(smtp.id)} style={{ marginLeft: 10 }}>Delete</button>
    </li>
  ))}
</ul>
{selectedIds.length > 0 && (
  <button onClick={handleBulkDelete} style={{ marginTop: 10, background: '#e74c3c', color: 'white' }}>
    Delete Selected ({selectedIds.length})
  </button>
)}

    </div>
  );
};



export default SMTPManager;
